import type { WorkspaceSearchFull } from '../../types';
import { safeJsonDateRequired } from './date';

export function normalizeSearchFullFileResults(data: WorkspaceSearchFull.File.Results<string>): WorkspaceSearchFull.File.Results | null {
  if (!data) return null;

  return {
    ...data,
    items: data.items.map(normalizeSearchFullFileResult),
  };
}

function normalizeSearchFullFileResult(data: WorkspaceSearchFull.File.Result<string>): WorkspaceSearchFull.File.Result {
  return {
    ...data,
    createdOn: safeJsonDateRequired(data.createdOn),
  };
}

export function normalizeSearchFullFolderResults(data: WorkspaceSearchFull.Folder.Results<string>): WorkspaceSearchFull.Folder.Results | null {
  if (!data) return null;

  return {
    ...data,
    items: data.items.map(normalizeSearchFullFolderResult),
  };
}

function normalizeSearchFullFolderResult(data: WorkspaceSearchFull.Folder.Result<string>): WorkspaceSearchFull.Folder.Result {
  return {
    ...data,
    createdOn: safeJsonDateRequired(data.createdOn),
  };
}

export function normalizeSearchFullBrandResults(data: WorkspaceSearchFull.Brand.Results<string>): WorkspaceSearchFull.Brand.Results | null {
  if (!data) return null;

  return {
    ...data,
    items: data.items.map(normalizeSearchFullBrandResult),
  };
}
function normalizeSearchFullBrandResult(data: WorkspaceSearchFull.Brand.Result<string>): WorkspaceSearchFull.Brand.Result {
  return {
    ...data,
    createdOn: safeJsonDateRequired(data.createdOn),
  };
}
export function normalizeSearchFullDashboardResults(data: WorkspaceSearchFull.Dashboard.Results<string>): WorkspaceSearchFull.Dashboard.Results | null {
  if (!data) return null;

  return {
    ...data,
    items: data.items.map(normalizeSearchFullDashboardResult),
  };
}
function normalizeSearchFullDashboardResult(data: WorkspaceSearchFull.Dashboard.Result<string>): WorkspaceSearchFull.Dashboard.Result {
  return {
    ...data,
    createdOn: safeJsonDateRequired(data.createdOn),
  };
}

export function normalizeSearchFullQuantAnalysesResults(data: WorkspaceSearchFull.QuantAnalyses.Results<string>): WorkspaceSearchFull.QuantAnalyses.Results | null {
  if (!data) return null;

  return {
    ...data,
    items: data.items.map(normalizeSearchFullQuantAnalysesResult),
  };
}

function normalizeSearchFullQuantAnalysesResult(data: WorkspaceSearchFull.QuantAnalyses.Result<string>): WorkspaceSearchFull.QuantAnalyses.Result {
  return {
    ...data,
    createdOn: safeJsonDateRequired(data.createdOn),
  };
}

export function normalizeSearchFullProjectResults(data: WorkspaceSearchFull.Project.Results<string>): WorkspaceSearchFull.Project.Results | null {
  if (!data) return null;

  return {
    ...data,
    items: data.items.map(normalizeSearchFullProjectResult),
  };
}

function normalizeSearchFullProjectResult(data: WorkspaceSearchFull.Project.Result<string>): WorkspaceSearchFull.Project.Result {
  return {
    ...data,
    createdOn: safeJsonDateRequired(data.createdOn),
  };
}

export function normalizeSearchFullTranscriptResults(data: WorkspaceSearchFull.Transcript.Results<string>): WorkspaceSearchFull.Transcript.Results | null {
  if (!data) return null;

  return {
    ...data,
    items: data.items.map(normalizeSearchFullTranscriptResult),
  };
}

function normalizeSearchFullTranscriptResult(data: WorkspaceSearchFull.Transcript.Result<string>): WorkspaceSearchFull.Transcript.Result {
  return {
    ...data,
    createdOn: safeJsonDateRequired(data.createdOn),
  };
}